// What each ready-made email is for. Jen filters by this on home and in the Library.
// Library emails take their file's group unless listed below; year emails are listed one by one.

import type { CategoryId, PlannedEmail } from './kit';
import { findPlanned } from '../plan';

export type Purpose = 'seasonal' | 'promos' | 'education' | 'events' | 'care' | 'news';

export const PURPOSES: { id: Purpose; label: string; hint: string }[] = [
  { id: 'seasonal', label: 'Seasonal', hint: 'Holidays and what to book this time of year.' },
  { id: 'promos', label: 'Promotions', hint: 'Gift cards, packages and openings.' },
  { id: 'education', label: 'Education', hint: 'Treatments explained and questions answered.' },
  { id: 'events', label: 'Life events', hint: 'Weddings, trips, reunions, photos. Count back from the date.' },
  { id: 'care', label: 'Client care', hint: 'Aftercare, rebooking, birthdays and thank yous.' },
  { id: 'news', label: 'Spa news', hint: 'Hours, closures, events and new faces.' },
];

const BY_FILE: Record<CategoryId, Purpose> = {
  moments: 'events',
  seasons: 'seasonal',
  treatments: 'education',
  askjen: 'education',
  care: 'care',
  news: 'news',
};

const BY_KEY: Record<string, Purpose> = {
  // year
  '2026-12-holiday': 'seasonal',
  '2027-01-new-year': 'seasonal',
  '2027-01-winter-skin': 'seasonal',
  '2027-02-valentines': 'seasonal',
  '2027-02-ask-jen': 'education',
  '2027-03-spring-glow': 'seasonal',
  '2027-04-redness-and-veins': 'seasonal',
  '2027-05-mothers-day': 'seasonal',
  '2027-05-event-season': 'events',
  '2027-06-sunscreen': 'education',
  '2027-06-iv-menu': 'seasonal',
  '2027-07-summer-safe': 'seasonal',
  '2027-08-fall-series': 'promos',
  '2027-09-routine': 'education',
  '2027-09-peel-season': 'seasonal',
  '2027-10-cozy-season': 'seasonal',
  '2027-11-holiday-timing': 'seasonal',
  '2027-11-black-friday': 'promos',
  '2027-12-year-end': 'care',
  // library emails that fit a different group than their file
  'lib-seasons-spot-check': 'education',
  'lib-seasons-gift-card-drawer': 'promos',
  'lib-care-gift-card': 'promos',
  'lib-care-year-plan': 'promos',
  'lib-news-last-minute': 'promos',
};

export function purposeOf(p: Pick<PlannedEmail, 'key' | 'category'>): Purpose {
  if (BY_KEY[p.key]) return BY_KEY[p.key];
  if (p.key.startsWith('welcome-')) return 'care';
  if (p.category) return BY_FILE[p.category];
  return 'seasonal';
}

export const purposeLabel = (id?: Purpose | 'own') => (id === 'own' ? 'Your own' : (PURPOSES.find((x) => x.id === id)?.label ?? ''));

/** What a saved email is for: the group of the ready-made email it started from, or "own" if she wrote it. */
export function purposeOfKey(key: string | null | undefined): Purpose | 'own' {
  const p = key ? findPlanned(key) : undefined;
  return p ? purposeOf(p) : 'own';
}
